export default __webpack_public_path__ + "static/media/IM.da0c2eb6.svg";